import { createElement } from '@syncfusion/ej2-base';
import { Button } from '@syncfusion/ej2-buttons';
import { DropDownButton } from '@syncfusion/ej2-splitbuttons';

import { PdfBitmap, PdfDocument, PdfPageOrientation, PdfPageSettings, SizeF } from '@syncfusion/ej2-pdf-export';

import api from 'api'

import { toast } from 'react-toastify'

function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export class TitleBar {
    tileBarDiv;
    documentTitle;
    documentTitleContentEditor;
    export;
    close;
    print;
    open;
    documentEditor;
    isRtl;
    dialogComponent;
    container;
    params;
    constructor(element, docEditor, isShareNeeded, isRtl, dialogComponent, container, params) {
        //initializes title bar elements.
        this.tileBarDiv = element;
        this.container = container;
        this.params = params;
        this.documentEditor = docEditor;
        this.isRtl = isRtl;
        this.dialogComponent = dialogComponent;
        this.initializeTitleBar(isShareNeeded);
        this.wireEvents();
    }
    initializeTitleBar = (isShareNeeded) => {
        let downloadText;
        let downloadToolTip;
        let printText;
        // let closeToolTip;
        let printToolTip;
        let openText;
        let documentTileText;
        let saveText;
        let explanationText;
        if (!this.isRtl) {
            downloadText = 'Download';
            downloadToolTip = 'Download this document.';
            printText = 'Print';
            printToolTip = 'Print this document (Ctrl+P).';
            // closeToolTip = 'Close this document';
            openText = 'Open';
            saveText = 'Save';
            documentTileText = 'Document Name. Click or tap to rename this document.';
            explanationText = 'Fields';
        }
        else {
            downloadText = 'تحميل';
            downloadToolTip = 'تحميل هذا المستند';
            printText = 'طباعه';
            printToolTip = 'طباعه هذا المستند (Ctrl + P)';
            openText = 'فتح';
            documentTileText = 'اسم المستند. انقر أو اضغط لأعاده تسميه هذا المستند';
        }
        // tslint:disable-next-line:max-line-length
        this.documentTitle = createElement('label', { id: 'documenteditor_title_name', styles: 'font-weight:400;text-overflow:ellipsis;white-space:pre;overflow:hidden;user-select:none;cursor:pointer' });
        // tslint:disable-next-line:max-line-length
        this.documentTitleContentEditor = createElement('div', { id: 'documenteditor_title_contentEditor', className: 'single-line' });
        this.documentTitleContentEditor.appendChild(this.documentTitle);
        this.tileBarDiv.appendChild(this.documentTitleContentEditor);
        this.documentTitleContentEditor.setAttribute('title', documentTileText);
        let btnStyles = 'float:right;background: transparent;box-shadow:none; font-family: inherit;border-color: transparent;'
            + 'border-radius: 2px;color:inherit;font-size:12px;text-transform:capitalize;height:28px;font-weight:400;margin-top: 2px;';
        // tslint:disable-next-line:max-line-length
        // this.close = this.addButton('e-icons e-close e-de-padding-right', "", btnStyles, 'de-close', closeToolTip, false);
        this.print = this.addButton('e-de-icon-Print e-de-padding-right', printText, btnStyles, 'de-print', printToolTip, false);
        this.open = this.addButton('e-de-icon-Open e-de-padding-right', openText, btnStyles, 'de-open', openText, false);
        let items = [
            // { text: 'Syncfusion Document Text (*.sfdt)', id: 'sfdt' },
            { text: 'Word Document (*.docx)', id: 'word' },
            // { text: 'Word Template (*.dotx)', id: 'dotx' },
            { text: 'Plain Text (*.txt)', id: 'txt' },
            { text: 'PDF (*.pdf)', id: 'pdf' },
        ];
        // tslint:disable-next-line:max-line-length
        this.export = this.addButton('e-de-icon-Download e-de-padding-right', downloadText, btnStyles, 'documenteditor-share', downloadToolTip, true, items);

        this.save = this.addButton('e-de-icon-Save e-de-padding-right', saveText, btnStyles, 'de-save', saveText, false);
        this.explanation = this.addButton('e-de-icon-Explanation e-de-padding-right', explanationText, btnStyles, 'de-save', explanationText, false);

        // this.export = this.addButton('e-de-icon-Save e-de-padding-right', `Save`, btnStyles, 'documenteditor-save', `Save File`);
        if (!isShareNeeded) {
            this.export.element.style.display = 'none';
        }
        else {
            this.open.element.style.display = 'none';
        }
        if (this.dialogComponent == null)
            this.close.element.style.display = 'none';
    };
    setTooltipForPopup() {
        // tslint:disable-next-line:max-line-length
        // document.getElementById('documenteditor-share-popup').querySelectorAll('li')[0].setAttribute('title', 'Download a copy of this document to your computer as an SFDT file.');
        // tslint:disable-next-line:max-line-length
        // document.getElementById('documenteditor-share-popup').querySelectorAll('li')[0].setAttribute('title', 'Download a copy of this document to your computer as a DOCX file.');
        // tslint:disable-next-line:max-line-length
        // document.getElementById('documenteditor-share-popup').querySelectorAll('li')[2].setAttribute('title', 'Download a copy of this document to your computer as a DOTX file.');
        // tslint:disable-next-line:max-line-length
        // document.getElementById('documenteditor-share-popup').querySelectorAll('li')[1].setAttribute('title', 'Download a copy of this document to your computer as a TXT file.');
    }
    wireEvents = () => {
        this.print.element.addEventListener('click', this.onPrint);
        // this.close.element.addEventListener('click', this.onClose);
        this.save.element.addEventListener('click', this.onSave);
        this.explanation.element.addEventListener('click', this.onShowExplanation);
        this.open.element.addEventListener('click', (e) => {
            if (e.target.id === 'de-open') {
                let fileUpload = document.getElementById('uploadfileButton');
                fileUpload.value = '';
                fileUpload.click();
            }
        });
        this.documentTitleContentEditor.addEventListener('keydown', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
                this.documentTitleContentEditor.contentEditable = 'false';
                if (this.documentTitleContentEditor.textContent === '') {
                    this.documentTitleContentEditor.textContent = 'Document1';
                }
            }
        });
        this.documentTitleContentEditor.addEventListener('blur', () => {
            if (this.documentTitleContentEditor.textContent === '') {
                this.documentTitleContentEditor.textContent = 'Document1';
            }
            this.documentTitleContentEditor.contentEditable = 'false';
            this.documentEditor.documentName = this.documentTitle.textContent;
        });
        this.documentTitleContentEditor.addEventListener('click', () => {
            this.updateDocumentEditorTitle();
        });
    };
    updateDocumentEditorTitle = () => {
        this.documentTitleContentEditor.contentEditable = 'true';
        this.documentTitleContentEditor.focus();
        window.getSelection().selectAllChildren(this.documentTitleContentEditor);
    };
    // Updates document title.
    updateDocumentTitle = () => {
        if (this.documentEditor.documentName === '') {
            this.documentEditor.documentName = 'Untitled';
        }
        this.documentTitle.textContent = this.documentEditor.documentName;

    };
    // tslint:disable-next-line:max-line-length
    addButton(iconClass, btnText, styles, id, tooltipText, isDropDown, items) {
        let button = createElement('button', { id: id, styles: styles });
        this.tileBarDiv.appendChild(button);
        button.setAttribute('title', tooltipText);
        if (isDropDown) {
            // tslint:disable-next-line:max-line-length
            let dropButton = new DropDownButton({ select: this.onExportClick, items: items, iconCss: iconClass, cssClass: 'e-caret-hide', content: btnText, open: () => { this.setTooltipForPopup(); } }, button);
            return dropButton;
        }
        else {
            let ejButton = new Button({ iconCss: iconClass, content: btnText }, button);
            return ejButton;
        }
    }
    onPrint = () => {
        this.documentEditor.print();
    };
    // onClose = () => {
    //     this.dialogComponent.hide();
    // };
    onShowExplanation = () => {
        const el = document.getElementById('archk-field-explanation');
        el.style.display = 'block'
    };
    onSave = async () => {
        const blob = await this.documentEditor.saveAsBlob('Docx')
        const name = this.documentTitleContentEditor.textContent;

        const base64 = await blobToBase64(blob)

        const payload = {
            name,
            base64,
            division: this.params.division,
        }

        if(this.params.word_document) payload.word_document = this.params.word_document

        const result = await api.word_documents.create(payload)
        if(!result.data) return toast.error(`Could not save template at this time, please try again.`)

        window.history.pushState({}, '', `/${this.params.division}/${result.data._id}`);
        toast.success(`Template saved successfully`)

    };

    save = (format) => {
        // tslint:disable-next-line:max-line-length
        this.documentEditor.save(this.documentEditor.documentName === '' ? 'sample' : this.documentEditor.documentName, format);
    };

    onExportClick = (args) => {
        let value = args.item.id;
        switch (value) {
            case 'word':
                this.documentEditor.save(this.documentEditor.documentName === '' ? 'sample' : this.documentEditor.documentName, 'Docx');
                break;
            case 'sfdt':
                this.documentEditor.save(this.documentEditor.documentName === '' ? 'sample' : this.documentEditor.documentName, 'Sfdt');
                break;
            case 'txt':
                this.documentEditor.save(this.documentEditor.documentName === '' ? 'sample' : this.documentEditor.documentName, 'Txt');
                break;
            case 'dotx':
                this.documentEditor.save(this.documentEditor.documentName === '' ? 'sample' : this.documentEditor.documentName, 'Dotx');
                break;
            case 'pdf':

                    let obj = this.container;
                    let pdfdocument = new PdfDocument();
                    let count = obj.documentEditor.pageCount;
                    obj.documentEditor.documentEditorSettings.printDevicePixelRatio = 2;
                    let loadedPage = 0;

                    const downloadPage = (i) => {
                        setTimeout(() => {
                            let format = 'image/jpeg';
                            // Getting pages as image
                            let image = obj.documentEditor.exportAsImage(i, format);
                            image.onload = function () {
                              let imageHeight = parseInt(
                                image.style.height.toString().replace('px', '')
                              );
                              let imageWidth = parseInt(
                                image.style.width.toString().replace('px', '')
                              );
                              let section = pdfdocument.sections.add();
                              let settings = new PdfPageSettings(0);
                              if (imageWidth > imageHeight) {
                                settings.orientation = PdfPageOrientation.Landscape;
                              }
                              settings.size = new SizeF(imageWidth, imageHeight);
                              (section).setPageSettings(settings);
                              let page = section.pages.add();
                              let graphics = page.graphics;
                              let imageStr = image.src.replace('data:image/jpeg;base64,', '');
                              let pdfImage = new PdfBitmap(imageStr);
                              graphics.drawImage(pdfImage, 0, 0, imageWidth, imageHeight);
                              loadedPage++;
                              if (loadedPage === count) {
                                  // Exporting the document as pdf
                                pdfdocument.save(
                                  (obj.documentEditor.documentName === ''
                                    ? 'sample'
                                    : obj.documentEditor.documentName) + '.pdf'
                                );
                              }
                            };
                          }, 500);
                    }

                    for (let i = 1; i <= count; i++) {
                        downloadPage(i)
                    }

                break;

            default: 
        }
    };
   
}
